import type { RoomView } from '@bm/shared';

/**
 * Die Namen der eigenen Mafia-Kollegen.
 *
 * `mafiaMemberIds` ist laut Projektion ausschließlich für Mafia-Spieler gefüllt
 * (und nie in der Lobby) — für alle anderen kommt hier von selbst eine leere
 * Liste heraus. Die eigene ID fällt raus: „deine Kollegen" meint die anderen.
 *
 * Bewusst nur aus `mafiaMemberIds` abgeleitet und nie aus `players[].role`:
 * die öffentliche Spielerliste kennt Rollen nur von Ausgeschiedenen, und ein
 * Rückgriff darauf wäre der Weg, auf dem ein Leak entstünde.
 */
export function mafiaColleagueNames(view: RoomView): string[] {
  return (view.mafiaMemberIds ?? [])
    .filter((id) => id !== view.self.id)
    .map((id) => view.players.find((player) => player.id === id)?.name)
    .filter((name): name is string => name !== undefined);
}
